export class SearchParamsModel {
  constructor(
    public proposalStatus = '',
    public proposalUserId = '',
    public goodsNameAndStandardName = '',
    public preferredStartOrderCode = '',
    public preferredDelivCatalogId = '',
    public classCode = '',
    public buyerId = '',
    public pcode = '',
    public masterInputStatus = '',
  ) { }

  private validations = [
    {
      validate: () => this.goodsNameAndStandardName.length <= 30,
      code: 'W0007',
      message: ['商品・規格名', '30']
    },
    {
      validate: () => {
        if (!this.preferredStartOrderCode) {
          return true;
        }
        return this.preferredStartOrderCode.length === 7;
      },
      code: 'W0024',
      message: ['希望受注コード']
    },
    {
      validate: () => {
        if (!this.preferredDelivCatalogId) {
          return true;
        }
        return this.preferredDelivCatalogId.length === 8;
      },
      code: 'W0024',
      message: ['希望企画回']
    },
    {
      validate: () => {
        if (!this.pcode) {
          return true;
        }
        return this.pcode.startsWith('P');
      },
      code: 'W0024',
      message: ['Ｐコード']
    }
  ];

  validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }
    return { code: error.code, message: error.message };
  }

  copy() {
    return new SearchParamsModel(
      this.proposalStatus,
      this.proposalUserId,
      this.goodsNameAndStandardName,
      this.preferredStartOrderCode,
      this.preferredDelivCatalogId,
      this.classCode,
      this.buyerId,
      this.pcode,
      this.masterInputStatus
    );
  }
}